import React from "react";

const RadioInputContext = React.createContext({});

export function useRadioInputContext() {
	return React.useContext(RadioInputContext);
}
export const { Provider } = RadioInputContext;
